// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {productSetItem, productAddItem,productGetItem, categorySetList} from '../../actions/productActions';
import {areaGetItem} from '../../actions/areaActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/product/ProductAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as categoryList} from '../../containers/product/CategoryListPage';
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.product.getItem,
        userValue: state.app.currentUser,
        categoryList : state.product.categoryList
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getCategoryList : () => {
        return(dispatch(categoryList({size: 100})));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {

    return (dispatch, getState) => {
        var formData = {
            'title'              : values.title,
            'description'        : values.description,
            'productCayegoryId'  : values.productCayegoryId,
            'price'              : parseInt(values.price),
            'commission'         : parseInt(values.commission),
            'image'              : values.image,
            'is_need_replacement': values.minimum_usage > 0 ? true : false,
            'has_gaurantee'      : values.guarantee > 0 ? true : false,
            'minimum_usage'      : parseInt(values.minimum_usage),
            'guarantee'          : parseInt(values.guarantee),
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('product/product', formData).then(res => {
            dispatch(productAddItem(res.data.lists));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addProduct'));
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/product/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let states = getState()
        var formData = {
            'title'              : values.title,
            'description'        : values.description,
            'productCayegoryId'  : values.productCayegoryId ? values.productCayegoryId : states.product.getItem.product_category._id,
            'price'              : parseInt(values.price),
            'commission'         : parseInt(values.commission),
            'is_need_replacement': values.is_need_replacement == 1 ? true : false,
            'has_gaurantee'      : values.has_gaurantee == 1 ? true : false,
            'minimum_usage'      : parseInt(values.minimum_usage),
            'guarantee'          : parseInt(values.guarantee),
            'image'              : values.image,
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('/product/product/'+id, formData).then(editRes => {
            dispatch(productSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/product/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('product/product/'+id).then(productInfo => {
            console.log(productInfo);
            dispatch(productGetItem(productInfo.data.result));
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
